/**
 * Generated by orval 🍺
 * Do not edit manually.
 * qcs control-plane
 * OpenAPI spec version: 0.1.0
 */

/**
 * Supported upstream platforms (v1).
 */
export type Platform = typeof Platform[keyof typeof Platform];


export const Platform = {
  blinkit: 'blinkit',
  zepto: 'zepto',
  instamart: 'instamart',
  bigbasket: 'bigbasket',
  flipkart: 'flipkart',
  amazon: 'amazon',
} as const;
